export class TimezoneConstants {
    /**
     * The default timezone string to use for displaying dates and times.
     */
    static readonly defaultTimezoneToDisplay = 'America/New_York';
}
